import { render } from "./IndexArrivalDeclarationPage.vue?vue&type=template&id=20364532&scoped=true"
import script from "./IndexArrivalDeclarationPage.vue?vue&type=script&lang=js"
export * from "./IndexArrivalDeclarationPage.vue?vue&type=script&lang=js"

import "./IndexArrivalDeclarationPage.vue?vue&type=style&index=0&id=20364532&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20364532"]])

export default __exports__